import * as React from 'react';
import { useMedia } from '../../../../helpers/media.js';
import '../../../../helpers/animation.js';
import '@lacedltd/design-tokens';
import { Item as Item$1, Trigger, IconContainer, PlusIcon, MinusIcon, Content } from './Item.styles.js';

var Item = React.forwardRef(function (_a, ref) {
    var title = _a.title, children = _a.children, _b = _a.darkMode, darkMode = _b === void 0 ? false : _b, sectionName = _a.sectionName, className = _a.className;
    var mobile = useMedia("s", "max");
    return (React.createElement(Item$1, { value: sectionName, ref: ref, className: className, darkMode: darkMode },
        React.createElement(Trigger, { darkMode: darkMode },
            title,
            React.createElement(IconContainer, null,
                React.createElement(PlusIcon, { size: mobile ? "m" : "l" }),
                React.createElement(MinusIcon, { size: mobile ? "m" : "l" }))),
        React.createElement(Content, null, children)));
});
Item.displayName = "Item";

export { Item as default };
//# sourceMappingURL=Item.js.map
